import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Number6kmrfn4klz39 as Number_0,
  Text2b8ye3kmips1o as Text,
  Bool1r3p37fvso3wz as Bool,
  Error21zp7h9320rwp as Error_0,
  asNumber3rgwwt2ok3oo4 as asNumber,
  asTextufk6946h4qqq as asText,
  compareValues1f9uh3diuktj1 as compareValues,
} from './ExcelValue.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_builtinFunctions2kgzbz596qdv5 as get_builtinFunctions } from './ExcelFunctions.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  isNaNymqb93xtq8w8 as isNaN_0,
  isInfinite12nl8hpz1hbp2 as isInfinite,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ExcelFunctionClass;
function ExcelFunction() {
  if (ExcelFunctionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ExcelFunction');
    ExcelFunctionClass = $;
  }
  return ExcelFunctionClass;
}
var NumberNodeClass;
function NumberNode() {
  if (NumberNodeClass === VOID) {
    class $ extends ExcelExpr() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      eval_4bdj8k_k$(ctx) {
        return new (Number_0())(this.value_1);
      }
      toString() {
        return 'NumberNode(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getNumberHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NumberNode()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'NumberNode');
    NumberNodeClass = $;
  }
  return NumberNodeClass;
}
var TextNodeClass;
function TextNode() {
  if (TextNodeClass === VOID) {
    class $ extends ExcelExpr() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      eval_4bdj8k_k$(ctx) {
        return new (Text())(this.value_1);
      }
      toString() {
        return 'TextNode(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TextNode()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'TextNode');
    TextNodeClass = $;
  }
  return TextNodeClass;
}
var BoolNodeClass;
function BoolNode() {
  if (BoolNodeClass === VOID) {
    class $ extends ExcelExpr() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      eval_4bdj8k_k$(ctx) {
        return new (Bool())(this.value_1);
      }
      toString() {
        return 'BoolNode(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getBooleanHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BoolNode()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'BoolNode');
    BoolNodeClass = $;
  }
  return BoolNodeClass;
}
var VarNodeClass;
function VarNode() {
  if (VarNodeClass === VOID) {
    class $ extends ExcelExpr() {
      constructor(name) {
        super();
        this.name_1 = name;
      }
      eval_4bdj8k_k$(ctx) {
        var tmp0_elvis_lhs = ctx.resolveVariable_7g1ib6_k$(this.name_1);
        return tmp0_elvis_lhs == null ? new (Error_0())('NAME', "Unknown variable '" + this.name_1 + "'") : tmp0_elvis_lhs;
      }
      toString() {
        return 'VarNode(name=' + this.name_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.name_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VarNode()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'VarNode');
    VarNodeClass = $;
  }
  return VarNodeClass;
}
var UnaryClass;
function Unary() {
  if (UnaryClass === VOID) {
    class $ extends ExcelExpr() {
      constructor(negate, operand) {
        super();
        this.negate_1 = negate;
        this.operand_1 = operand;
      }
      eval_4bdj8k_k$(ctx) {
        var value = this.operand_1.eval_4bdj8k_k$(ctx);
        var num = asNumber(value);
        if (num instanceof Error_0())
          return num;
        var n = (num instanceof Number_0() ? num : THROW_CCE()).value_1;
        return new (Number_0())(this.negate_1 ? -n : n);
      }
      toString() {
        return 'Unary(negate=' + this.negate_1 + ', operand=' + toString(this.operand_1) + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.negate_1);
        result = imul(result, 31) + hashCode(this.operand_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Unary()))
          return false;
        if (!(this.negate_1 === other.negate_1))
          return false;
        if (!equals(this.operand_1, other.operand_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Unary');
    UnaryClass = $;
  }
  return UnaryClass;
}
var PercentClass;
function Percent() {
  if (PercentClass === VOID) {
    class $ extends ExcelExpr() {
      constructor(operand) {
        super();
        this.operand_1 = operand;
      }
      eval_4bdj8k_k$(ctx) {
        var value = this.operand_1.eval_4bdj8k_k$(ctx);
        var num = asNumber(value);
        if (num instanceof Error_0())
          return num;
        return new (Number_0())((num instanceof Number_0() ? num : THROW_CCE()).value_1 / 100.0);
      }
      toString() {
        return 'Percent(operand=' + toString(this.operand_1) + ')';
      }
      hashCode() {
        return hashCode(this.operand_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Percent()))
          return false;
        if (!equals(this.operand_1, other.operand_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Percent');
    PercentClass = $;
  }
  return PercentClass;
}
var BinaryClass;
function Binary() {
  if (BinaryClass === VOID) {
    class $ extends ExcelExpr() {
      constructor(op, left, right) {
        super();
        this.op_1 = op;
        this.left_1 = left;
        this.right_1 = right;
      }
      eval_4bdj8k_k$(ctx) {
        var l = this.left_1.eval_4bdj8k_k$(ctx);
        var r = this.right_1.eval_4bdj8k_k$(ctx);
        if (this.op_1.equals(BinaryOp_Concat_getInstance())) {
          var err = firstError(listOf([l, r]));
          if (!(err == null))
            return err;
          return new (Text())(asText(l) + asText(r));
        }
        if (this.op_1.equals(BinaryOp_Eq_getInstance()) || this.op_1.equals(BinaryOp_NotEq_getInstance()) || this.op_1.equals(BinaryOp_Lt_getInstance()) || this.op_1.equals(BinaryOp_Gt_getInstance()) || this.op_1.equals(BinaryOp_LtEq_getInstance()) || this.op_1.equals(BinaryOp_GtEq_getInstance())) {
          var _destruct__k2r9zo = compareValues(l, r);
          var cmp = _destruct__k2r9zo.component1_7eebsc_k$();
          var err_0 = _destruct__k2r9zo.component2_7eebsb_k$();
          if (!(err_0 == null))
            return err_0;
          var result;
          switch (this.op_1.ordinal_1) {
            case 6:
              result = cmp === 0;
              break;
            case 7:
              result = !(cmp === 0);
              break;
            case 8:
              result = cmp < 0;
              break;
            case 9:
              result = cmp > 0;
              break;
            case 10:
              result = cmp <= 0;
              break;
            default:
              result = cmp >= 0;
              break;
          }
          return new (Bool())(result);
        }
        var ln = asNumber(l);
        if (ln instanceof Error_0())
          return ln;
        var rn = asNumber(r);
        if (rn instanceof Error_0())
          return rn;
        var lv = (ln instanceof Number_0() ? ln : THROW_CCE()).value_1;
        var rv = (rn instanceof Number_0() ? rn : THROW_CCE()).value_1;
        var tmp;
        switch (this.op_1.ordinal_1) {
          case 0:
            tmp = numeric(lv + rv);
            break;
          case 1:
            tmp = numeric(lv - rv);
            break;
          case 2:
            tmp = numeric(lv * rv);
            break;
          case 3:
            tmp = rv === 0.0 ? new (Error_0())('DIV/0', 'Division by zero') : numeric(lv / rv);
            break;
          case 4:
            var tmp_0;
            if (lv === 0.0 && rv === 0.0) {
              tmp_0 = new (Error_0())('NUM', '0^0 is undefined');
            } else {
              var tmp_1;
              if (lv < 0.0) {
                // Inline function 'kotlin.math.floor' call
                tmp_1 = !(rv === Math.floor(rv));
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp_0 = new (Error_0())('NUM', 'Negative base with fractional exponent');
              } else {
                // Inline function 'kotlin.math.pow' call
                var tmp$ret$1 = Math.pow(lv, rv);
                tmp_0 = numeric(tmp$ret$1);
              }
            }

            tmp = tmp_0;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
      toString() {
        return 'Binary(op=' + this.op_1.toString() + ', left=' + toString(this.left_1) + ', right=' + toString(this.right_1) + ')';
      }
      hashCode() {
        var result = this.op_1.hashCode();
        result = imul(result, 31) + hashCode(this.left_1) | 0;
        result = imul(result, 31) + hashCode(this.right_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Binary()))
          return false;
        if (!this.op_1.equals(other.op_1))
          return false;
        if (!equals(this.left_1, other.left_1))
          return false;
        if (!equals(this.right_1, other.right_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Binary');
    BinaryClass = $;
  }
  return BinaryClass;
}
var CallClass;
function Call() {
  if (CallClass === VOID) {
    class $ extends ExcelExpr() {
      constructor(name, args) {
        super();
        this.name_1 = name;
        this.args_1 = args;
      }
      eval_4bdj8k_k$(ctx) {
        var tmp0_elvis_lhs = ctx.resolveFunction_y47x7u_k$(this.name_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return new (Error_0())('NAME', "Unknown function '" + this.name_1 + "'");
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var fn = tmp;
        return fn.invoke_pr27w4_k$(this.args_1, ctx);
      }
      toString() {
        return 'Call(name=' + this.name_1 + ', args=' + toString(this.args_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.name_1);
        result = imul(result, 31) + hashCode(this.args_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Call()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!equals(this.args_1, other.args_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Call');
    CallClass = $;
  }
  return CallClass;
}
var ExcelExprClass;
function ExcelExpr() {
  if (ExcelExprClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ExcelExpr');
    ExcelExprClass = $;
  }
  return ExcelExprClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      build_cw5jyg_k$(variables, extraFunctions) {
        var v = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = variables.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.collections.component1' call
          var k = element.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var value = element.get_value_j01efc_k$();
          // Inline function 'kotlin.text.uppercase' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.collections.set' call
          var key = k.toUpperCase();
          v.put_4fpzoq_k$(key, value);
        }
        var f = HashMap().new_kotlin_collections_HashMap_gc38m_k$(get_builtinFunctions());
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_0 = extraFunctions.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'kotlin.collections.component1' call
          var k_0 = element_0.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var value_0 = element_0.get_value_j01efc_k$();
          // Inline function 'kotlin.text.uppercase' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.collections.set' call
          var key_0 = k_0.toUpperCase();
          f.put_4fpzoq_k$(key_0, value_0);
        }
        return new (ExcelContext())(v, f);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var ExcelContextClass;
function ExcelContext() {
  if (ExcelContextClass === VOID) {
    class $ {
      constructor(variables, functions) {
        variables = variables === VOID ? HashMap().new_kotlin_collections_HashMap_2a5kxx_k$() : variables;
        functions = functions === VOID ? HashMap().new_kotlin_collections_HashMap_2a5kxx_k$() : functions;
        this.variables_1 = variables;
        this.functions_1 = functions;
      }
      resolveVariable_7g1ib6_k$(name) {
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = name.toUpperCase();
        return this.variables_1.get_wei43m_k$(tmp$ret$0);
      }
      resolveFunction_y47x7u_k$(name) {
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = name.toUpperCase();
        return this.functions_1.get_wei43m_k$(tmp$ret$0);
      }
    }
    initMetadataForClass($, 'ExcelContext', ExcelContext);
    ExcelContextClass = $;
  }
  return ExcelContextClass;
}
function evalAll(_this__u8e3s4, ctx) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(_this__u8e3s4, 10));
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$2 = item.eval_4bdj8k_k$(ctx);
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  return destination;
}
function firstError(_this__u8e3s4) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element instanceof Error_0()) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  BinaryOp_Add_instance = new (BinaryOp())('Add', 0);
  BinaryOp_Sub_instance = new (BinaryOp())('Sub', 1);
  BinaryOp_Mul_instance = new (BinaryOp())('Mul', 2);
  BinaryOp_Div_instance = new (BinaryOp())('Div', 3);
  BinaryOp_Pow_instance = new (BinaryOp())('Pow', 4);
  BinaryOp_Concat_instance = new (BinaryOp())('Concat', 5);
  BinaryOp_Eq_instance = new (BinaryOp())('Eq', 6);
  BinaryOp_NotEq_instance = new (BinaryOp())('NotEq', 7);
  BinaryOp_Lt_instance = new (BinaryOp())('Lt', 8);
  BinaryOp_Gt_instance = new (BinaryOp())('Gt', 9);
  BinaryOp_LtEq_instance = new (BinaryOp())('LtEq', 10);
  BinaryOp_GtEq_instance = new (BinaryOp())('GtEq', 11);
}
var BinaryOp_Add_instance;
var BinaryOp_Sub_instance;
var BinaryOp_Mul_instance;
var BinaryOp_Div_instance;
var BinaryOp_Pow_instance;
var BinaryOp_Concat_instance;
var BinaryOp_Eq_instance;
var BinaryOp_NotEq_instance;
var BinaryOp_Lt_instance;
var BinaryOp_Gt_instance;
var BinaryOp_LtEq_instance;
var BinaryOp_GtEq_instance;
var BinaryOpClass;
function BinaryOp() {
  if (BinaryOpClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'BinaryOp');
    BinaryOpClass = $;
  }
  return BinaryOpClass;
}
function numeric(d) {
  if (isNaN_0(d))
    return new (Error_0())('NUM', 'Result is not a number');
  if (isInfinite(d))
    return new (Error_0())('NUM', 'Result is too large');
  return new (Number_0())(d);
}
function BinaryOp_Add_getInstance() {
  static_init();
  return BinaryOp_Add_instance;
}
function BinaryOp_Sub_getInstance() {
  static_init();
  return BinaryOp_Sub_instance;
}
function BinaryOp_Mul_getInstance() {
  static_init();
  return BinaryOp_Mul_instance;
}
function BinaryOp_Div_getInstance() {
  static_init();
  return BinaryOp_Div_instance;
}
function BinaryOp_Pow_getInstance() {
  static_init();
  return BinaryOp_Pow_instance;
}
function BinaryOp_Concat_getInstance() {
  static_init();
  return BinaryOp_Concat_instance;
}
function BinaryOp_Eq_getInstance() {
  static_init();
  return BinaryOp_Eq_instance;
}
function BinaryOp_NotEq_getInstance() {
  static_init();
  return BinaryOp_NotEq_instance;
}
function BinaryOp_Lt_getInstance() {
  static_init();
  return BinaryOp_Lt_instance;
}
function BinaryOp_Gt_getInstance() {
  static_init();
  return BinaryOp_Gt_instance;
}
function BinaryOp_LtEq_getInstance() {
  static_init();
  return BinaryOp_LtEq_instance;
}
function BinaryOp_GtEq_getInstance() {
  static_init();
  return BinaryOp_GtEq_instance;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  BinaryOp_Add_getInstance as BinaryOp_Add_getInstance21e6unb8ihszv,
  BinaryOp_Concat_getInstance as BinaryOp_Concat_getInstance3f2zrl641dkzq,
  BinaryOp_Div_getInstance as BinaryOp_Div_getInstance35qfbeys2ty0v,
  BinaryOp_Eq_getInstance as BinaryOp_Eq_getInstance3k5gqsqqy0m8l,
  BinaryOp_GtEq_getInstance as BinaryOp_GtEq_getInstance3okul41zdqyt3,
  BinaryOp_Gt_getInstance as BinaryOp_Gt_getInstance1daaj0ilv714d,
  BinaryOp_LtEq_getInstance as BinaryOp_LtEq_getInstance13m3rw35pfurr,
  BinaryOp_Lt_getInstance as BinaryOp_Lt_getInstance33j0pgyd00cpr,
  BinaryOp_Mul_getInstance as BinaryOp_Mul_getInstance27o8h7njrmnvz,
  BinaryOp_NotEq_getInstance as BinaryOp_NotEq_getInstance3tyaa09ac7jzy,
  BinaryOp_Pow_getInstance as BinaryOp_Pow_getInstance1mkwbubduk7i7,
  BinaryOp_Sub_getInstance as BinaryOp_Sub_getInstancea51dds4zxi3,
  Companion_instance as Companion_instance1m4lyta31lqem,
  Binary as Binary3afyp00u76wim,
  BoolNode as BoolNode3tzl71ld7m729,
  Call as Call7ulg0xobrp7l,
  NumberNode as NumberNode1xmay0dkzrjy8,
  Percent as Percent1jcj19m9plnqy,
  TextNode as TextNodehpx4og0kbkvh,
  Unary as Unary39zfajhusip1v,
  VarNode as VarNode11doayw0szb1g,
  ExcelFunction as ExcelFunction2k41pwq8xg6wo,
  evalAll as evalAll3oat76nn6xi8b,
  firstError as firstError1efmomhi1a6qo,
};
//endregion

//# sourceMappingURL=ExcelExpr.mjs.map
